/*
 *
 * GenericShopList
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 30-Jun-2025
*/

import React from 'react'
import PortalMessage from 'Utility/PortalMessage'

const formattedMessage = {
  title: (<PortalMessage id='t.app.shopList' defaultMessage='Lista punti vendita' />),
  closeLabel: <PortalMessage id='t.app.close' defaultMessage='Chiudi' />,
  sectionTitle: <PortalMessage id='t.app.genericshoplist.sectionTitle' defaultMessage='Stai associando alla casella i seguenti punti vendita. Una volta creata la casella dispute potrai associare a essa nuovi punti vendita, ma non eliminare quelli già presenti.' />,
  noShopsAvailable: <PortalMessage id='t.app.genericshoplist.noShopsAvailable' defaultMessage='Nessun punto vendita, riprova più tardi' />
}

export default formattedMessage
